<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" top="3vh" @close="close">
    <!-- 所属用户 -->
    <el-form :rules="rules" ref="ruleForm" :model="form" label-width="100px">
      <el-form-item label="包裹单号" prop="code">
        <el-input v-model.trim="form.code"></el-input>
      </el-form-item>
      <el-form-item label="用户" prop="code">
        <el-select v-model="form.uid" filterable remote reserve-keyword placeholder="请输入关键词"
          :remote-method="remoteMethod" :loading="loading">
          <el-option v-for="item in user_list" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="纸箱类型" prop="">
        <el-select v-model="form.carton" placeholder="请选择">
          <el-option  label="未选择" :value="0"></el-option>
          <el-option v-for="item in list1" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递袋">
        <el-select v-model="form.courier_bag" placeholder="请选择">
          <el-option  label="未选择" :value="0"></el-option>
          <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物品加固">
        <el-select v-model="form.reinforce" placeholder="请选择">
          <el-option  label="未选择" :value="0">
          </el-option>
          <el-option v-for="item in list3" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="贴面单">
        <el-radio-group v-model="form.face_veneer">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="贴产地标">
        <el-radio-group v-model="form.label">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="其他">
        <el-input v-model.trim="form.other"></el-input>
      </el-form-item>
      <el-form-item label="包裹内物">
        <el-input v-model.trim="form.item"></el-input>
      </el-form-item>
      <el-form-item label="数量">
        <el-input v-model.trim="form.num"></el-input>
      </el-form-item>
      <el-form-item label="重量">
        <el-input v-model.trim="form.weight"></el-input>
      </el-form-item>
      <el-form-item label="尺寸">
        <el-input v-model.trim="form.long"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {
    Monad_update, //新用户添加修改
    MonadOrder_detail, //详情
    Monad_list, //用户列表
    MonadCarton_list,//纸箱列表
    MonadOrder_update,//新包裹修改
  } from '@/api/new_user.js'

  export default {
    name: 'UserManagementEdit',
    data() {
      return {
        loading: false,
        dialogFormVisible: false,
        form: {
          "uid": null, //用户id
          "carton": null, //纸箱类型
          "courier_bag": null, //快递袋
          "face_veneer": null, //贴面单
          "label": null, //贴产地标
          "reinforce": null, //物品加固
          "other": null, //其他
          "item": null, //包裹内物
          "long": null, //长
          "weight": null, //重量
          "num": null //数量
        },
        user_list: [],
        rules: {},
        title: '',
        listInfo: [],
        brandList: [],
        list1: [], //产地类型
        list2: [], //包装袋
        list3: [], //加固类型
      }
    },

    created() {},
    methods: {
      // 获取详情数据
      showEdit(row) {
        if (row) {
          // 编辑
          this.title = '编辑'
          var data = {
            id: row.id
          }
          MonadOrder_detail(data).then(res => {
            console.log(res.data)
            this.form = res.data
            this.dialogFormVisible = true
            this.get_user_list(res.data.uid)
            this.get_MonadCarton_list(1) //纸箱
            this.get_MonadCarton_list(2) //快递袋
            this.get_MonadCarton_list(3) //加固
          })
        } else {
          //新增
          this.title = '新增'
          this.dialogFormVisible = true
        }
      },
      remoteMethod(query) {
        this.loading = true;
        Monad_list({
          keyword: query
        }).then(res => {
          this.loading = false;
          this.user_list = res.data.list
        })
      },
      get_user_list(id) {
        // 获取用户列表
        Monad_list({
          id
        }).then(res => {
          this.user_list = res.data.list
        })
      },
      // 获取纸箱列表
      get_MonadCarton_list(type) {
        MonadCarton_list({
          type: type
        }).then(res => {
          if (type == 1) {
            this.list1 = res.data.list
          }
          if (type == 2) {
            this.list2 = res.data.list
          }
          if (type == 3) {
            this.list3 = res.data.list
          }
        })
      },
      // 点击关闭弹窗
      close() {
        this.form = {
          "uid": null, //用户id
          "carton": null, //纸箱类型
          "courier_bag": null, //快递袋
          "face_veneer": null, //贴面单
          "label": null, //贴产地标
          "reinforce": null, //物品加固
          "other": null, //其他
          "item": null, //包裹内物
          "long": null, //长
          "weight": null, //重量
          "num": null //数量
        }
        this.dialogFormVisible = false
      },
      // 点击提交更改
      save() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            MonadOrder_update(this.form).then(res => {
              this.close()
              this.$emit('formChange', true)
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
    },
  }
</script>
<style scoped>
  .black {
    font-weight: bold;
    color: #000000;
  }

  .xinxi {
    border: 1px solid #dcdfe6;
    margin-bottom: 5px;
    padding: 10px;
    box-sizing: border-box;
  }
</style>
